import { cn } from "admin-ui/utils/cn"
import { IconProps } from "."

export default function CogSixTooth({
  className,
  transform,
  ...reset
}: Readonly<IconProps>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", className)}
      transform={transform}
      {...reset}
    >
      <g clipPath="url(#cog_six_tooth)">
        <path
          d="M8 9.99902C9.10457 9.99902 10 9.10359 10 7.99902C10 6.89445 9.10457 5.99902 8 5.99902C6.89543 5.99902 6 6.89445 6 7.99902C6 9.10359 6.89543 9.99902 8 9.99902Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.489 6.46917L12.6632 6.17761C12.5726 5.94561 12.4686 5.71539 12.3406 5.49317C12.2126 5.27095 12.065 5.0665 11.9094 4.87183L12.0694 4.01139C12.1806 3.41495 11.9032 2.81228 11.3779 2.50917L11.0659 2.32872C10.5397 2.02472 9.88011 2.08606 9.41877 2.48072L8.75655 3.04695C8.25878 2.9705 7.74944 2.9705 7.24278 3.04695L6.58055 2.47983C6.11922 2.08517 5.45878 2.02383 4.93344 2.32783L4.62144 2.50828C4.09522 2.81139 3.81878 3.41406 3.92989 4.0105L4.08989 4.86828C3.76989 5.26739 3.51566 5.70917 3.33255 6.1785L2.51122 6.46828C1.93878 6.67006 1.55566 7.21139 1.55566 7.8185V8.1785C1.55566 8.78561 1.93878 9.32695 2.51122 9.52872L3.337 9.82028C3.42766 10.0523 3.53078 10.2816 3.65966 10.5038C3.78855 10.7261 3.93522 10.9305 4.09078 11.1261L3.92989 11.9865C3.81878 12.5829 4.09611 13.1856 4.62144 13.4887L4.93344 13.6692C5.45966 13.9732 6.11922 13.9118 6.58055 13.5172L7.24278 12.9501C7.73966 13.0265 8.249 13.0265 8.75478 12.9501L9.41789 13.5181C9.87922 13.9127 10.5397 13.9741 11.065 13.6701L11.377 13.4896C11.9032 13.1856 12.1797 12.5838 12.0686 11.9874L11.9086 11.1287C12.2277 10.7296 12.4828 10.2887 12.665 9.81939L13.4872 9.52961C14.0597 9.32783 14.4428 8.7865 14.4428 8.17939V7.81939C14.4428 7.21228 14.0597 6.67095 13.4872 6.46917H13.489Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="cog_six_tooth">
          <rect
            width="15"
            height="15"
            fill="white"
            transform="translate(0.5 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
